export enum SegmentEvent {
  ACCOUNTING_FILE_UPLOAD = 'Accounting_File_Upload',
  ASSET_CREATED = 'Asset_Created',
  VIDEO_PLAYER_STARTED = 'VideoPlayer.Started',
  VIDEO_PLAYER_SEGMENT_WATCHED = 'VideoPlayer.SegmentWatched',
  VIDEO_PLAYER_ENDED = 'VideoPlayer.Ended',
  CHECKOUT_COMPLETED = 'Checkout.Completed',
  CHECKOUT_KICKOFF_CLICKED = 'CheckoutKickoff.Clicked',
  CHECKOUT_KICKOFF_BOOKED = 'CheckoutKickoff.Booked',
  CHECKOUT_PAYMENT_SELECTED = 'CheckoutPayment.Selected',
  CHECKOUT_STARTED = 'Checkout.Started',
  CHECKOUT_UPLIFT_STARTED = 'CheckoutUplift.Started',
  CHECKOUT_UPLIFT_COMPLETED = 'CheckoutUplift.Completed',
  CLEARDESK_ESTATE_LIST_INBOX_CLICKED = 'ClearDesk_EstateListInbox.Clicked',
  CLEARDESK_LOG_INTO_ESTATE = 'ClearDesk.LogIntoEstate',
  CLEARDESK_UNREAD_MESSAGE_CLICKED = 'ClearDesk_UnreadMessageWidget.Clicked',
  DIAGNOSTIC_COMPLETED = 'Diagnostic.Completed',
  DIAGNOSTIC_LAUNCH_CLICKED = 'DiagnosticLaunch.Clicked',
  DIAGNOSTIC_RESTART_CLICKED = 'DiagnosticRestart.Clicked',
  DIAGNOSTIC_RESULTS_PAGE_DOWNLOADED = 'DiagnosticResultsPage.Downloaded',
  DIAGNOSTIC_RESULTS_PAGE_VIEWED = 'DiagnosticResultsPage.Viewed',
  DIAGNOSTIC_PAGE_VIEWED = 'DiagnosticPage.Viewed',
  DIAGNOSTIC_TOOL_SHARED = 'DiagnosticTool.Shared',
  DIAGNOSTIC_TOOL_SHARE_CLICKED = 'DiagnosticToolShare.Clicked',
  DOCUMENT_AI_WILL_SKIP = 'DocumentAI.Will.Skip',
  DOCUMENT_AI_WILL_EXTRACT = 'DocumentAI.Will.Extract',
  DOCUMENT_AI_WILL_VALIDATE_MODAL_OPENED = 'DocumentAI.Will.ValidateModalOpened',
  DOCUMENT_AI_WILL_VALIDATE_DATA = 'DocumentAI.Will.ValidateData',
  DOCUMENT_AI_WILL_VIEW_WILL = 'DocumentAI.Will.ViewWill',
  DOCUMENT_FILE_UPLOAD = 'Document_File_Upload',
  ESTATE_CHURNED = 'Estate_Churned',
  ESTATE_CREATED = 'Estate_Created',
  ESTATE_MARKETPLACE_CLICK_TO_INTENT = 'Estate_Marketplace_Click_To_Intent',
  EXECUTOR_DOWNLOADED_INSTRUCTIONS = 'Executor_Downloaded_Instructions',
  EXPORT_TEMPLATE_DOWNLOADED = 'ExportTemplate.Downloaded',
  FINANCIAL_ACCOUNT_PLAID_CONNECTION = 'FinancialAccount_Plaid_Connection',
  FINANCIAL_ADVISOR_DEMO_PORTAL_CLICKED = 'Advisor.DemoPortal.Clicked',
  FINANCIAL_ADVISOR_ONBOARDING_EXPLORE_DEMO_CLICKED = 'Advisor.Onboarding.ExploreDemo.Clicked',
  FINANCIAL_ADVISOR_ONBOARDING_DISCOVER_PORTAL_CLICKED = 'Advisor.Onboarding.DiscoverPortal.Clicked',
  FINANCIAL_ADVISOR_ONBOARDING_SOLUTIONS_AND_PRICING_VIEWED = 'Advisor.Onboarding.SolutionsAndPricing.Viewed',
  ADVISOR_PORTAL_ADVISOR_PRO_UPGRADE_STARTED = 'AdvisorPortal.Global.AdvisorProUpgradeStarted',
  ADVISOR_PORTAL_CREATE_TEAM_STARTED = 'AdvisorPortal.Teams.CreateTeamStarted',
  ADVISOR_PORTAL_OPPORTUNITIES_MARK_AS_REVIEWED = 'AdvisorPortal.Opportunities.MarkAsReviewed',
  ADVISOR_PORTAL_OPPORTUNITIES_SCAN_MANUALLY_CLICKED = 'AdvisorPortal.Opportunities.ScanManuallyClicked',
  ADVISOR_PORTAL_PLANNING_REFERRAL_STARTED = 'AdvisorPortal.Global.PlanningReferralStarted',
  ADVISOR_PORTAL_REFERRAL_PLANNING_FLOW_CONTACT_ADDED = 'AdvisorPortal.ReferralPlanningFlow.ContactAdded',
  ADVISOR_PORTAL_REFERRAL_PLANNING_FLOW_DIAGNOSTIC_TOOL_STARTED = 'AdvisorPortal.ReferralPlanningFlow.DiagnosticToolStarted',
  ADVISOR_PORTAL_REFERRAL_PLANNING_FLOW_INVENTORY_ADDED = 'AdvisorPortal.ReferralPlanningFlow.InventoryAdded',
  ADVISOR_PORTAL_REFERRAL_PLANNING_FLOW_NO_SOLUTION_BOOK_CONSULTATION_CLICKED =
    'AdvisorPortal.ReferralPlanningFlow.NoSolutionBookConsultationClicked',
  ADVISOR_PORTAL_REFERRAL_PLANNING_FLOW_VAULT_SETUP_SKIPPED = 'AdvisorPortal.ReferralPlanningFlow.VaultSetupSkipped',
  ADVISOR_PORTAL_REFERRALS_PLANNING_FILTER_ENABLED = 'AdvisorPortal.ReferralsPlanning.FilterEnabled',
  ADVISOR_PORTAL_SETTLEMENT_REFERRAL_STARTED = 'AdvisorPortal.Global.SettlementReferralStarted',
  ADVISOR_PORTAL_SOLUTIONS_PRICING_OPENED = 'AdvisorPortal.Global.SolutionsPricingOpened',
  ADVISOR_PORTAL_TOOLS_OPENED = 'AdvisorPortal.Tools.Opened',
  ADVISOR_PORTAL_CLIENT_NAME_CLICKED = 'AdvisorPortal.ClientName.Clicked',
  ADVISOR_PORTAL_POST_CREATION_MODAL_VIEWED = 'AdvisorPortal.PostCreationModal.Viewed',
  ADVISOR_PORTAL_POST_CREATION_MODAL_OPTION_SELECTED = 'AdvisorPortal.PostCreationModal.OptionSelected',
  ADVISOR_PORTAL_POST_CREATION_MODAL_DISMISSED = 'AdvisorPortal.PostCreationModal.Dismissed',
  ADVISOR_PORTAL_REFERRAL_ACTION_CLICKED = 'AdvisorPortal.ReferralAction.Clicked',
  FREEWILL_BILLING_PAGE_VIEWED = 'FreeWill_BillingPage.Viewed',
  FREEWILL_DASHBOARD_PAGE_VIEWED = 'FreeWill_DashboardPage.Viewed',
  FREEWILL_DELETED_ACCOUNT = 'FreeWill_DeletedAccount',
  FREEWILL_DISTRIBUTION_SECTION_COMPLETED = 'FreeWill_DistributionSection.Completed',
  FREEWILL_ESTATE_ACCOUNTING_PAGE_VIEWED = 'FreeWill_EstateAccountingPage.Viewed',
  FREEWILL_EXECUTORSHIP_SECTION_COMPLETED = 'FreeWill_ExecutorshipSection.Completed',
  FREEWILL_FILE_MANAGEMENT_PAGE_VIEWED = 'FreeWill_FileManagementPage.Viewed',
  FREEWILL_FUNERAL_PRE_ARRANGEMENT_SECTION_COMPLETED = 'FreeWill_FuneralPreArrangementSection.Completed',
  FREEWILL_GENERATE_WILL_CLICKED = 'FreeWill_GenerateWill.Clicked',
  FREEWILL_GENERATE_WILL_VIEWED = 'FreeWill_GenerateWill.Viewed',
  FREEWILL_GUIDANCE_CLICKED = 'FreeWill_Guidance.Clicked',
  FREEWILL_INBOX_PAGE_VIEWED = 'FreeWill_InboxPage.Viewed',
  FREEWILL_JURISDICTION_CHECK_VIEWED = 'FreeWill_JurisdictionCheck.Viewed',
  FREEWILL_JURISDICTION_NOT_SUPPORTED = 'FreeWill_JurisdictionNotSupported',
  FREEWILL_PERSONAL_INFO_INELIGIBLE_CLICKED = 'FreeWill_PersonalInfo_Ineligible.Clicked',
  FREEWILL_PERSONAL_INFO_SECTION_COMPLETED = 'FreeWill_PersonalInfoSection.Completed',
  FREEWILL_PERSONAL_INFO_VIEWED = 'FreeWill_PersonalInfo.Viewed',
  FREEWILL_POA_PERSONAL_CARE_COMPLETED = 'FreeWill_PoaPersonalCare.Completed',
  FREEWILL_POA_PERSONAL_CARE_VIEWED = 'FreeWill_PoaPersonalCare.Viewed',
  FREEWILL_POA_PROPERTY_COMPLETED = 'FreeWill_PoaProperty.Completed',
  FREEWILL_POA_PROPERTY_VIEWED = 'FreeWill_PoaProperty.Viewed',
  FREEWILL_REFERRAL_PAGE_CLICKED = 'FreeWill_ReferralPage.Clicked',
  FREEWILL_REFERRAL_PAGE_VIEWED = 'FreeWill_ReferralPage.Viewed',
  FREEWILL_REFERRAL_PROMPT_CLICKED = 'FreeWill_ReferralPrompt.Clicked',
  FREEWILL_REFERRAL_SHARE_CLICKED = 'FreeWill_ReferralShare.Clicked',
  FREEWILL_REFERRAL_SIGNUP_COMPLETED = 'FreeWill_ReferralSignup.Completed',
  FREEWILL_REFERRAL_SIGNUP_VIEWED = 'FreeWill_ReferralSignup.Viewed',
  FREEWILL_SIGNUP_CLICKED = 'FreeWill_Signup.Clicked',
  FREEWILL_SIGNUP_VIEWED = 'FreeWill_Signup.Viewed',
  FREEWILL_STARTED = 'FreeWill.Started',
  FREEWILL_UPGRADE_BUTTON_CLICKED = 'FreeWill_UpgradeButton.Clicked',
  FREEWILL_YOUR_WILL_CALLREQUEST_CLICKED = 'FreeWill_YourWill_CallRequest.Viewed',
  FREEWILL_YOUR_WILL_DOWNLOAD_CLICKED = 'FreeWill_YourWill_Download.Viewed',
  FREEWILL_YOUR_WILL_SELECTPLAN_CLICKED = 'FreeWill_YourWill_SelectPlan.Viewed',
  FREEWILL_YOUR_WILL_VIEWED = 'FreeWill_YourWill.Viewed',
  GUIDANCESTEP_FILE_UPLOAD = 'GuidanceStep_File_Upload',
  GUIDANCESTEP_STEPS_CLICKED = 'GuidanceStep_Steps_Clicked',
  STEP_COMPLETED = 'Step_%_Completed',
  STEP_VIEWED_FIRST = 'Step_%_ViewedFirst',
  STEP_VIEWED = 'Step_%_Viewed',
  INBOX_CLICK = 'Inbox_Click',
  INBOX_MESSAGE_SENT = 'Inbox_Message_Sent',
  INBOX_NEW_CONVERSATION = 'Inbox_New_Conversation',
  LIABILITY_CREATED = 'Liability_Created',
  LOGIN_COMPLETED = 'Login_Completed',
  NEW_REGISTRATION = 'New_Registration',
  PROBATE_APPROVED = 'Probate.Approved',
  PROBATE_REJECTED = 'Probate.Rejected',
  PROBATE_SUBMITTED = 'Probate.Submitted',
  PROFESSIONAL_INVITE_SENT = 'Professional_Invite_Sent',
  STANDARD_LOGIN_CLICKED = 'Standard_Login.Clicked',
  STANDARD_UPSELL_PAY_TO_ACCESS_BUTTON_CLICKED = 'Standard.Upsell.PayToAccessButton.Clicked',
  STANDARD_UPSELL_CALLBACK_REQUEST_CLICKED = 'Standard.Upsell.CallbackRequest.Clicked',
  SIGN_UP_COMPLETED = 'Signup_Completed',
  TRUSTPILOT_REVIEW_PAGE_VIEWED = 'TrustPilot_ReviewPage.Viewed',
  TRUSTPILOT_REVIEW_PAGE_RATED = 'TrustPilot_ReviewPage.Rated',
  TRUSTPILOT_REVIEW_REQUEST_SENT = 'TrustPilot_ReviewRequest.Sent',
  UPSELL_CV_DASHBOARD_CLICKED = 'UpsellCVDashboard.Clicked',
  VIEWED_SIGNUP_PAGE = 'Viewed.SignupPage',
  VIEWED_TRIAGE_WELCOME_PAGE = 'Viewed.Triage.WelcomePage',
  TRIAGE_WELCOME_PAGE_COMPLETED = 'Triage.WelcomePage.Completed',
  VIEWED_TRIAGE_NAME_PAGE = 'Viewed.Triage.NamePage',
  TRIAGE_NAME_PAGE_COMPLETED = 'Triage.NamePage.Completed',
  VIEWED_ONBOARDING_INTAKE_MEETING_MODAL = 'Viewed.Onboarding.IntakeMeetingModal',
  ONBOARDING_INTAKE_MEETING_MODAL_COMPLETED = 'Onboarding.IntakeMeetingModal.Completed',
  VIEWED_ONBOARDING_CONTINUE_JOURNEY_MODAL = 'Viewed.Onboarding.ContinueJourneyModal',
  ONBOARDING_CONTINUE_JOURNEY_MODAL_QUIT = 'Onboarding.ContinueJourneyModal.Quit',
  ONBOARDING_CONTINUE_JOURNEY_MODAL_COMPLETED = 'Onboarding.ContinueJourneyModal.Completed',
  ONBOARDING_WELCOME_MODAL_VIEWED = 'Onboarding.WelcomeModal.Viewed',
  ONBOARDING_CONTINUE_JOURNEY_MODAL_VIEWED = 'Onboarding.ContinueJourneyModal.Viewed',
  ONBOARDING_WELCOME_MODAL_QUIT = 'Onboarding.WelcomeModal.Quit',
  ONBOARDING_WELCOME_MODAL_COMPLETED = 'Onboarding.WelcomeModal.Completed',
  SMART_TEMPLATE_EDITOR_MODAL_OPENED = 'SmartTemplateEditorModal.Opened',
  SMART_TEMPLATE_EDITOR_MODAL_SAVED = 'SmartTemplateEditorModal.Saved',
  SMART_TEMPLATE_EDITOR_MODAL_CHANGES_DISCARDED = 'SmartTemplateEditorModal.ChangesDiscarded',
  VIEWED_DASHBOARD_PAGE = 'Viewed.DashboardPage',
  SELF_SERVE_SIGNUP_PAGE_VIEWED = 'Self-serve.SignupPage.Viewed',
  VIEWED_AFTERCARE_SIGNUP_PAGE = 'Viewed.Aftercare.SignupPage',
  SELF_SERVE_SIGNUP_PAGE_COMPLETED = 'Self-serve.SignupPage.Completed',
  ONBOARDING_WELCOME_PAGE_VIEWED = 'Onboarding.WelcomePage.Viewed',
  ONBOARDING_WELCOME_PAGE_COMPLETED = 'Onboarding.WelcomePage.Completed',
  ONBOARDING_NAME_PAGE_VIEWED = 'Onboarding.NamePage.Viewed',
  ONBOARDING_NAME_PAGE_COMPLETED = 'Onboarding.NamePage.Completed',
  ONBOARDING_JURISDICTION_VIEWED = 'Onboarding.Jurisdiction.Viewed',
  ONBOARDING_JURISDICTION_COMPLETED = 'Onboarding.Jurisdiction.Completed',
  ONBOARDING_CONSENT_PAGE_VIEWED = 'Onboarding.ConsentPage.Viewed',
  ONBOARDING_CONSENT_PAGE_COMPLETED = 'Onboarding.ConsentPage.Completed',
  VIEWED_STANDARD_TRIAGE_SITUATION_PAGE = 'Viewed.Standard.Triage.SituationPage',
  STANDARD_TRIAGE_SITUATION_PAGE_COMPLETED = 'Standard.Triage.SituationPage.Completed',
  VIEWED_STANDARD_TRIAGE_RECOMMENDATION_PAGE = 'Viewed.Standard.Triage.RecommendationPage',
  STANDARD_TRIAGE_RECOMMENDATION_PAGE_SELECTED = 'Standard.Triage.RecommendationPage.Selected',
  STANDARD_TRIAGE_RECOMMENDATION_PAGE_COMPLETED = 'Standard.Triage.RecommendationPage.Completed',
  STANDARD_TRIAGE_RECOMMENDATION_PAGE_CONSULTATION_CLICKED = 'Standard.Triage.RecommendationPage.ConsultationClicked',
  STANDARD_TRIAGE_RECOMMENDATION_PAGE_CONSULTATION_BOOKED = 'Standard.Triage.RecommendationPage.ConsultationBooked',
  VIEWED_STANDARD_TRIAGE_WARNING_PAGE = 'Viewed.Standard.Triage.WarningPage',
  STANDARD_TRIAGE_WARNING_PAGE_COMPLETED = 'Standard.Triage.WarningPage.Completed',
  VIEWED_WELCOME_MODAL = 'Viewed.WelcomeModal',
  WELCOME_MODAL_CLICKED_PLAY_VIDEO = 'WelcomeModal.ClickedPlayVideo',
  WELCOME_MODAL_CLICKED_LETS_GET_STARTED = 'WelcomeModal.ClickedLetsGetStarted',
  VIEWED_IMPORTANT_TO_KNOW_EXECUTOR_DUTIES = 'Viewed.ImportantToKnow.ExecutorDuties',
  IMPORTANT_TO_KNOW_EXECUTOR_DUTIES_SKIPPED = 'ImportantToKnow.ExecutorDuties.Skipped',
  VIEWED_IMPORTANT_TO_KNOW_CLEARESTATE_ROLE = 'Viewed.ImportantToKnow.ClearEstateRole',
  IMPORTANT_TO_KNOW_CLEARESTATE_ROLE_SKIPPED = 'ImportantToKnow.ClearEstateRole.Skipped',
  VIEWED_IMPORTANT_TO_KNOW_TIMELINE_ASSESS = 'Viewed.ImportantToKnow.Timeline.Assess',
  IMPORTANT_TO_KNOW_TIMELINE_ASSESS_SKIPPED = 'ImportantToKnow.Timeline.Assess.Skipped',
  VIEWED_SKIPPED_IMPORTANT_TO_KNOW_MODAL = 'Viewed.SkippedImportantToKnowModal',
  VIEWED_BOOK_KICKOFF = 'Viewed.BookKickoff',
  BOOK_KICKOFF_COMPLETED = 'BookKickoff.Completed',
  TESTATE_VALIDATE_STEP_EXTRACT_DATA = 'Testate_Validate_Step_Extract_Data',
  TESTATE_VALIDATE_STEP_VALIDATE_DATA = 'Testate_Validate_Step_Validate_Data',
  AI_RESEARCH_PERPLEXITY_CLICKED = 'AiResearch.PerplexityClicked',
  AI_RESEARCH_INBOX_USE_AI_RESEARCH = 'AiResearch.InboxUseAiResearch',
  ANNOUNCEMENT_DISPLAYED = 'Announcement.Displayed',
  ANNOUNCEMENT_OPEN_RELEASE_UPDATES_CLICKED = 'Announcement.OpenReleaseUpdatesClicked',
  ANNOUNCEMENT_GOT_IT_CLICKED = 'Announcement.GotItClicked',
  STEP_FAQ_CLICKED = 'Step.FAQ.Clicked',
  STEP_FAQ_CLOSED = 'Step.FAQ.Closed',
  PAYWALL_PAYMENT_MODAL_VIEWED = 'Paywall.PaymentModal.Viewed',
  PAYWALL_PAYMENT_MODAL_COMPLETED = 'Paywall.PaymentModal.Completed',
  PAYWALL_PAYMENT_MODAL_QUIT = 'Paywall.PaymentModal.Quit',
  STEP_FAQ_EXPANDED = 'Step.FAQ.Expanded',
  SUPPORT_CHATFLOW_CLICKED = 'Support.Chatflow.Clicked',
  MICROTIP_UNDERLINED_TOOLTIP_CLICKED = 'Microtip.UnderlinedToolTip.Clicked',
  MICROTIP_UNDERLINED_TOOLTIP_CLOSED = 'Microtip.UnderlinedToolTip.Closed',
  MICROTIP_HELP_ICON_CLICKED = 'Microtip.HelpIcon.Clicked',
  MICROTIP_HELP_ICON_CLOSED = 'Microtip.HelpIcon.Closed',
  FIRST_NATIONS_DISCLAIMER_EXPANDED = 'FirstNations.DisclaimerExpanded',
  FIRST_NATIONS_EDUCATION_BLOCK_EXPANDED = 'FirstNations.EducationBlockExpanded',
  ANNUAL_REVIEW_LANDING_PAGE_VIEWED = 'AnnualReview.LandingPage.Viewed',
  ANNUAL_REVIEW_LANDING_PAGE_COMPLETED = 'AnnualReview.LandingPage.Completed',
  ANNUAL_REVIEW_LANDING_PAGE_QUIT = 'AnnualReview.LandingPage.Quit',
  ANNUAL_REVIEW_FAMILY_CHANGES_VIEWED = 'AnnualReview.FamilyChanges.Viewed',
  ANNUAL_REVIEW_FAMILY_CHANGES_COMPLETED = 'AnnualReview.FamilyChanges.Completed',
  ANNUAL_REVIEW_FAMILY_CHANGES_QUIT = 'AnnualReview.FamilyChanges.Quit',
  ANNUAL_REVIEW_NOMINATION_CHANGES_VIEWED = 'AnnualReview.NominationChanges.Viewed',
  ANNUAL_REVIEW_NOMINATION_CHANGES_COMPLETED = 'AnnualReview.NominationChanges.Completed',
  ANNUAL_REVIEW_NOMINATION_CHANGES_QUIT = 'AnnualReview.NominationChanges.Quit',
  ANNUAL_REVIEW_FINANCIAL_CHANGES_VIEWED = 'AnnualReview.FinancialChanges.Viewed',
  ANNUAL_REVIEW_FINANCIAL_CHANGES_COMPLETED = 'AnnualReview.FinancialChanges.Completed',
  ANNUAL_REVIEW_FINANCIAL_CHANGES_QUIT = 'AnnualReview.FinancialChanges.Quit',
  ANNUAL_REVIEW_BUSINESS_CHANGES_VIEWED = 'AnnualReview.BusinessChanges.Viewed',
  ANNUAL_REVIEW_BUSINESS_CHANGES_COMPLETED = 'AnnualReview.BusinessChanges.Completed',
  ANNUAL_REVIEW_BUSINESS_CHANGES_QUIT = 'AnnualReview.BusinessChanges.Quit',
  ANNUAL_REVIEW_LOCATION_CHANGES_VIEWED = 'AnnualReview.LocationChanges.Viewed',
  ANNUAL_REVIEW_LOCATION_CHANGES_COMPLETED = 'AnnualReview.LocationChanges.Completed',
  ANNUAL_REVIEW_LOCATION_CHANGES_QUIT = 'AnnualReview.LocationChanges.Quit',
  ANNUAL_REVIEW_ADDITIONAL_NOTES_VIEWED = 'AnnualReview.AdditionalNotes.Viewed',
  ANNUAL_REVIEW_ADDITIONAL_NOTES_COMPLETED = 'AnnualReview.AdditionalNotes.Completed',
  ANNUAL_REVIEW_ADDITIONAL_NOTES_QUIT = 'AnnualReview.AdditionalNotes.Quit',
  ANNUAL_REVIEW_SUMMARY_PAGE_VIEWED = 'AnnualReview.SummaryPage.Viewed',
  ANNUAL_REVIEW_SUMMARY_PAGE_COMPLETED = 'AnnualReview.SummaryPage.Completed',
  ANNUAL_REVIEW_SUMMARY_PAGE_QUIT = 'AnnualReview.SummaryPage.Quit',
  ANNUAL_REVIEW_RECOMMENDATION_PAGE_VIEWED = 'AnnualReview.RecommendationPage.Viewed',
  ANNUAL_REVIEW_RECOMMENDATION_PAGE_COMPLETED = 'AnnualReview.RecommendationPage.Completed',
  ANNUAL_REVIEW_RECOMMENDATION_PAGE_QUIT = 'AnnualReview.RecommendationPage.Quit',
  ANNUAL_REVIEW_BOOK_MEETING_CLICKED = 'AnnualReview.BookMeeting.Clicked',
  PLANNING_FINAL_REVIEW_ERROR_BANNER_VIEWED = 'Planning.FinalReview.ErrorBannerViewed',
  PLANNING_FINAL_REVIEW_HELP_TOOLTIP_VIEWED = 'Planning.FinalReview.HelpTooltipViewed',
  PLANNING_UPDATE_CARD_CLICKED = 'Planning.UpdateCard.Clicked',
  PLANNING_PEOPLE_IN_PLAN_OPENED = 'Planning.PeopleInPlan.Opened',
  EDITOR_DOCUMENT_OPENED_IN_NEW_TAB = 'Editor.Document.OpenedInNewTab',
  ADVISOR_PORTAL_DOCUMENT_UPLOADED = 'AdvisorPortal.Document.Uploaded',
  ADVISOR_PORTAL_DOCUMENT_ANALYSIS_STARTED = 'AdvisorPortal.Document.AnalysisStarted',
  ADVISOR_PORTAL_DOCUMENT_ANALYSIS_COMPLETED = 'AdvisorPortal.Document.AnalysisCompleted',
  ADVISOR_PORTAL_DOCUMENTS_TAB_VIEWED = 'AdvisorPortal.DocumentsTab.Viewed',
  PLANNING_WILL_DOWNLOADED = 'Planning.Will.Downloaded',
  PLANNING_CONFLICT_WARNING_SHOWN = 'Planning.ConflictWarning.Shown',
  PLANNING_CONFLICT_WARNING_CHANGE_SELECTION = 'Planning.ConflictWarning.ChangeSelection',
  PLANNING_CONFLICT_WARNING_OVERRIDDEN = 'Planning.ConflictWarning.Overridden',
  DOCUMENT_DOWNLOADED = 'Document.Downloaded',
  DOCUMENT_VIEWED = 'Document.Viewed',
  MEMOIR_LANDING_VIEWED = 'Memoir.Landing.Viewed',
  MEMOIR_NOTIFY_ME_SUBMITTED = 'Memoir.NotifyMe.Submitted',
  MEMOIR_FEATURE_CHECKLIST_SUBMITTED = 'Memoir.FeatureChecklist.Submitted',
  MEMOIR_FEEDBACK_FORM_SUBMITTED = 'Memoir.FeedbackForm.Submitted',
  PLANNING_CONTACT_CREATED = 'Planning.Contact.Created'
}
